/**
 * Atajos del icono PWA en Android (Web App Manifest shortcuts).
 */

export const ATAJOS_PWA = [
  {
    name: 'Nuevo gasto',
    short_name: 'Gasto',
    url: '/nuevo-gasto'
  },
  {
    name: 'Resumen',
    short_name: 'Resumen',
    url: '/resumen'
  },
  {
    name: 'Lista de la compra',
    short_name: 'Compra',
    url: '/lista-compra'
  },
  {
    name: 'Nutrición',
    short_name: 'Nutrición',
    url: '/nutricion'
  }
];

export function debeAbrirNuevoGasto(route) {
  if (!route) return false;
  if (route.meta && route.meta.abrirFormulario) return true;
  if (route.path === '/nuevo-gasto') return true;
  const nuevo = route.query && route.query.nuevo;
  return nuevo === '1' || nuevo === 1 || nuevo === true;
}

/** Enlace del email/push de gasto compartido: debe quedarse en Gastos, no ir a vista_inicio. */
export function esNotificacionGasto(route) {
  if (!route || route.path !== '/') return false;
  const n = route.query && route.query.notificacion;
  return n === 'gasto' || n === '1' || n === true;
}

const RUTAS_AUTH = ['/login', '/registro', '/recuperar-password', '/resetear-password'];

export function esRedirectInterno(redirect) {
  if (!redirect || typeof redirect !== 'string') return false;
  if (!redirect.startsWith('/') || redirect.startsWith('//')) return false;
  const path = redirect.split('?')[0];
  if (RUTAS_AUTH.includes(path)) return false;
  return true;
}
